import { render, staticRenderFns } from "./DetailPage.vue?vue&type=template&id=1d61f3e6&scoped=true&"
import script from "./DetailPage.vue?vue&type=script&lang=js&"
export * from "./DetailPage.vue?vue&type=script&lang=js&"
import style0 from "./DetailPage.vue?vue&type=style&index=0&id=1d61f3e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d61f3e6",
  null
  
)

export default component.exports